import Reveal from '@/components/base/Reveal';

export default function TestimonialsSection() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            Client Success Story
          </span>

          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            How Synergy Auto Spa Used a Simple Flash Sale Strategy
          </h2>

          <p className="mt-4 text-foreground-600 leading-relaxed">
            A real example of how Josh helped a client structure, promote, and
            follow up on a focused offer using a simple marketing system.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left — Instagram Reel */}
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl bg-gradient-to-tr from-primary-500/15 to-transparent blur-2xl" />

              <div className="relative rounded-2xl border border-white/10 bg-background-100 p-3 md:p-5">
                <video
                  className="w-full h-auto"
                  src="/assets/videos/testimonial-1.mp4"
                  controls
                />
              </div>
            </div>
          </Reveal>

          {/* Right — Strategy */}
          <Reveal delay={100}>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 text-accent-400 px-3 py-1 text-xs font-label font-semibold">
              <i className="ri-flashlight-line"></i>
              Flash Sale Strategy
            </span>

            <h3 className="mt-6 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              A Simple Offer, Connected to the Right Systems
            </h3>

            <p className="mt-5 text-foreground-600 leading-relaxed">
              Josh helped Synergy Auto Spa launch a focused flash sale strategy,
              connect the promotion to the right systems, and follow up with the
              audience through multiple channels.
            </p>

            <div className="mt-8 space-y-4">
              {[
                'Tease the offer',
                'Soft promote',
                'Text, email, and post the offer',
                'Use scarcity to follow up',
              ].map((item, index) => (
                <div
                  key={item}
                  className="flex items-center gap-4 rounded-xl border border-white/10 bg-background-100 p-4">
                  <span className="shrink-0 w-9 h-9 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400 font-label font-semibold text-sm">
                    {index + 1}
                  </span>

                  <p className="text-sm md:text-base text-foreground-700 font-medium">
                    {item}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-8 rounded-2xl border border-primary-500/20 bg-primary-500/10 p-6">
              <div className="flex items-start gap-4">
                <span className="shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                  <i className="ri-lightbulb-flash-line text-lg"></i>
                </span>

                <div>
                  <p className="font-heading font-semibold text-foreground-950">
                    The Strategy
                  </p>

                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    Build interest before the promotion, introduce the offer
                    gradually, distribute it across multiple channels, then use
                    scarcity-based follow-up to drive action.
                  </p>
                </div>
              </div>
            </div>

            <a
              href="https://www.instagram.com/reel/DNyWGdBWlvY/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center justify-center gap-2 rounded-md border border-primary-500/40 px-6 py-3 text-sm font-label font-semibold text-foreground-950 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-500 hover:bg-primary-500/10">
              Watch on Instagram
              <i className="ri-instagram-line text-lg"></i>
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
